import Table from "./Table.vue";

export * from "./table.type";
export default Table;
